/**
 * FeedbackCompletionMode
 */
export enum FeedbackCompletionMode {
    DISABLED = 'disabled',
    MESSAGE = 'message',
    EVALUATION = 'evaluation'
}
